export default "__VITE_ASSET__QMooXYbz__"